import { type } from "os";
import { isNullOrUndefined } from "util";

//
// AGNES - Technical Support Web
//
// TechnicalSupportBrowseTechReportController.js
//
// Copyright (c) 2015 Toyota Central Europe - Czech s.r.o.
//
// Permission is hereby granted, free of charge, to any person
// obtaining a copy of this software and associated documentation
// files (the "Software"), to deal in the Software without
// restriction, including without limitation the rights to use,
// copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the
// Software is furnished to do so, subject to the following
// conditions:
//
// The above copyright notice and this permission notice shall be
// included in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
// OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
// HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
// WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
// FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
// OTHER DEALINGS IN THE SOFTWARE.
//

angular.module("Agnes")
    .controller("MenuPricingMenuController", [
        "$scope", "$sessionStorage", "$http", "$activity", "$notification", "$window", "$user", "Blob", "FileSaver", "$oidc",
        function ($scope, $sessionStorage, $http, $activity, $notification, $window, user, Blob, FileSaver, oidc) {
            $scope.menuTypesSelected = [];

            // Storage
            $scope.$storage = $sessionStorage.$default({
                menuPricingMenu: {
                    brand: null,
                    model: null,
                    menuType: null,

                    orderName: "name",
                    orderDesc: false
                }
            });

            // Repairer
            $scope.$watch("$storage.repairer", function (newValue, oldValue) {
                if (!angular.isUndefinedNullOrEmpty(newValue) && newValue.id !== -1 && newValue.id !== oldValue.id) {
                    return $scope
                        .loadBrands()
                }
            });

            // Browse
            $scope.sorting = function (orderName) {
                if ($scope.$storage.menuPricingMenu.orderName === orderName) {
                    $scope.$storage.menuPricingMenu.orderDesc = !$scope.$storage.menuPricingMenu.orderDesc;
                } else {
                    $scope.$storage.menuPricingMenu.orderName = orderName;
                    $scope.$storage.menuPricingMenu.orderDesc = false;
                }
            };

            $scope.sortingClass = function (orderName) {
                if ($scope.$storage.menuPricingMenu.orderName === orderName) {
                    if ($scope.$storage.menuPricingMenu.orderDesc) {
                        return "fa fa-caret-down";
                    } else {
                        return "fa fa-caret-up";
                    }
                } else {
                    return "";
                }
            };

            $scope.loadModels = function () {
                $activity.start();
                return $http
                    .get("/api/menu-pricing/model/" + $scope.$storage.repairer.party.id, {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        },
                        params: {
                            brandId: isNullOrUndefined($scope.$storage.menuPricingMenu.brand) ? null : $scope.$storage.menuPricingMenu.brand.id
                        }
                    })
                    .then(function (response) {
                        $scope.models = response.data;
                    }, function (response) {
                        $notification.addError(response.status, response);
                    }).then(function () {
                        $activity.finish();
                    });
            };

            $scope.loadBrands = function () {
                $activity.start();
                $http
                    .get("/api/menu-pricing/brand/" + $scope.$storage.repairer.party.id, {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        $scope.brands = response.data;
                        if (!angular.isUndefinedNullOrEmpty($scope.brands) && $scope.brands.length > 0) {
                            $scope.$storage.menuPricingMenu.brand = $scope.brands[0];
                        }
                    }, function (response) {
                        $notification.addError(response.status, response);
                    }).then(function () {
                        $activity.finish();
                    });
            };

            $scope.loadMenuTypes = function (getData) {
                $activity.start();
                $http
                    .get("/api/menu-pricing/menu-type", {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        $scope.menuTypes = response.data;
                        if (!angular.isUndefinedNullOrEmpty($scope.menuTypes) && $scope.menuTypes.length > 0) {
                            $scope.$storage.menuPricingMenu.typeMenu = $scope.menuTypes[0];
                        }
                    }, function (response) {
                        $notification.addError(response.status, response);
                    }).then(function () {
                        $activity.finish();
                    });
            };

            $scope.$watch("$storage.menuPricingMenu.model", function (newValue, oldValue) {
                if (!angular.isUndefinedNullOrEmpty($scope.$storage.repairer) && $scope.$storage.repairer.id !== -1)
                    $scope.refresh();
            });

            $scope.$watch("$storage.menuPricingMenu.brand", function (newValue, oldValue) {
                if (!angular.isUndefinedNullOrEmpty($scope.$storage.repairer) && $scope.$storage.repairer.id !== -1)
                    return $scope
                        .loadModels()
                        .then(function () {
                            return $scope.refresh();
                        })
            });

            $scope.$watch("$storage.menuPricingMenu.typeMenu", function (newValue, oldValue) {
                if (!angular.isUndefinedNullOrEmpty($scope.$storage.repairer) && $scope.$storage.repairer.id !== -1 && newValue !== null) {
                    $scope.refresh();
                }
            });

            $scope.refresh = function () {
                if (!angular.isUndefinedNullOrEmpty($scope.$storage.menuPricingMenu.typeMenu)) {
                    $activity.start();
                    return $http
                        .get("/api/menu-pricing/menu", {
                            params: {
                                menuTypeId: $scope.$storage.menuPricingMenu.typeMenu.id,
                                modelNameId: angular.isUndefinedNullOrEmpty($scope.$storage.menuPricingMenu.model) ? null : $scope.$storage.menuPricingMenu.model.id,
                                brandId: angular.isUndefinedNullOrEmpty($scope.$storage.menuPricingMenu.brand) ? null : $scope.$storage.menuPricingMenu.brand.id,
                                partyId: $scope.$storage.repairer.party.id
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            $scope.list = response.data;
                        }, function (response) {
                            $notification.addError(response.status, response);
                        }).then(function () {
                            $activity.finish();
                        });
                }
            };

            $scope.clearFilter = function () {
                $scope.$storage.menuPricingMenu.brand = null;
                $scope.$storage.menuPricingMenu.model = null;
                if (!angular.isUndefinedNullOrEmpty($scope.menuTypes) && $scope.menuTypes.length > 0) {
                    if ($scope.$storage.menuPricingMenu.typeMenu.id == $scope.menuTypes[0].id) {
                        $scope.refresh();
                    } else {
                        $scope.$storage.menuPricingMenu.typeMenu = $scope.menuTypes[0];
                    }
                }
            };

            $scope.downloadFile = function (type, item, withCodes) {
                $activity.start();
                return $http
                    .get("/api/menu-pricing/menu/" + type, {
                        params: {
                            menuId: item.id,
                            partyId: $scope.$storage.repairer.party.id,
                            showPartCode: withCodes
                        },
                        responseType: 'arraybuffer',
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        var contentDisposition = response.headers("content-disposition");
                        var regex = /filename="*([^"].+[^"])"*;/g;
                        var result = regex.exec(contentDisposition);
                        var fileName = result[1];
                        var data = new Blob([response.data], { type: response.headers("content-type") });
                        FileSaver.saveAs(data, fileName);
                    }, function (response) {
                        $notification.addError(response.status, response);
                    }).then(function () {
                        $activity.finish();
                    });
            }

            $scope.toggleSelectionPDF = function (menuId) {
                var idx = $scope.menuTypesSelected.indexOf(menuId);
                if (idx > -1) {
                    $scope.menuTypesSelected.splice(idx, 1);
                } else {
                    $scope.menuTypesSelected.push(menuId);
                }
            };

            $scope.openMenusInPDF = function () {
                $activity.start();
                return $http
                    .get('/api/menu-pricing/menu/collection/' + $scope.menuTypesSelected.join(',') + '/pdf', {
                        params: {
                            partyId: $scope.$storage.repairer.party.id
                        },
                        responseType: 'arraybuffer',
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        var contentDisposition = response.headers("content-disposition");
                        var regex = /filename="*([^"].+[^"])"*;/g;
                        var result = regex.exec(contentDisposition);
                        var fileName = result[1];
                        var data = new Blob([response.data], { type: response.headers("content-type") });
                        FileSaver.saveAs(data, fileName);
                    }, function (response) {
                        $notification.addError(response.status, response);
                    }).then(function () {
                        $activity.finish();
                    });
            };

            $scope.user = user;

            // On Load
            if (!angular.isUndefinedNullOrEmpty($scope.$storage.repairer) && $scope.$storage.repairer.id !== -1) {
                $scope.loadMenuTypes();
                $scope.loadBrands();
            }
        }
    ]);